/*
 * Created on 22.02.2017
 *
 * Copyright(c) 1995 - 2017 T-Systems Multimedia Solutions GmbH
 * Riesaer Str. 5, 01129 Dresden
 * All rights reserved.
 */
import { Component, EventEmitter, Input, OnDestroy, OnInit, Optional, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { LoggingService } from '../../utils/logging.service';
import { FormComponent } from '../form-form/form.component';

/**
 * Diese Komponente stellt einen Aktionsbutton innerhalb von Formularen dar.
 *
 * Usage:
 *
 * <common-form-button (clickEvt)="cancel()" value="ABBRECHEN" [btnDisabled]="dirty" [isPrimary]="true"></common-form-button>
 *
 * oder
 *
 *  <common-form-button-element [btnValue]="btnTxt" (clickEvt)="update()" [isPrimary]="true"></common-form-button-element>
 *  (Das setzen von [isPrimary]="true" fügt die Klasse "btn--primary" hinzu!)
 *
 * @author Thomas Hamm (thm@mms-dresden.de)
 */
@Component({
    selector: 'common-form-button',
    template: `
        <button type='button' (click)="clickEvent()"
                class="text-center btn"
                [ngClass]="{'btn--primary': isPrimary}"
                [disabled]="btnDisabled">
            <ng-content></ng-content>
            {{btnValue || value}}
        </button>`
})
export class ButtonElementComponent implements OnInit, OnDestroy {
    @Input() value: string = '';
    @Input() btnValue: string = '';
    @Input() btnDisabled: boolean;
    @Input() deactivatable: boolean;
    @Input() isPrimary: boolean = false;

    @Output() clickEvt: EventEmitter<any> = new EventEmitter();

    private ngUnsubscribe$: Subject<void> = new Subject<void>();

    constructor(@Optional() private fc: FormComponent, private loggingService: LoggingService) {
    }

    ngOnInit() {
        if (this.fc && this.fc.formGroupElement && this.deactivatable) {
            this.fc.formGroupElement.statusChanges.pipe(distinctUntilChanged())
                .pipe(takeUntil(this.ngUnsubscribe$))
                .subscribe(formStatus => {
                    switch (formStatus) {
                        case 'VALID':
                            this.btnDisabled = false;
                            break;
                        case 'INVALID':
                            this.btnDisabled = true;
                            break;
                        default:
                            break;
                    }

                    this.loggingService.debug('STATUS des Formulars: ' + formStatus + ', Button wird ' +
                        (!this.btnDisabled ? 'NICHT ' : '') + 'disabled!');
                });

            if (this.fc.formGroupElement.status && this.fc.formGroupElement.status === 'INVALID') {
                this.btnDisabled = true;
            }
        }
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }

    clickEvent() {
        if (!this.btnDisabled) {
            this.clickEvt.emit();
        }
    }
}
